import {ICrudOptions} from './crud';

//#region INTERFACE IUserAccessFeatureAutoOrderingSettings
export interface IUserAccessFeatureAutoOrderingSettings {
  openOrderSettings: ICrudOptions;
  orderSettings: ICrudOptions;
}

//#endregion

//#region CONST _DEFAULT_USER_ACCESS_ORDER_SETTINGS
export const _DEFAULT_USER_ACCESS_ORDER_SETTINGS: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_OPEN_ORDER_SETTINGS
export const _DEFAULT_USER_ACCESS_OPEN_ORDER_SETTINGS: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_FEATURE_AUTO_ORDERING_SETTINGS
export const _DEFAULT_USER_ACCESS_FEATURE_AUTO_ORDERING_SETTINGS: Readonly<IUserAccessFeatureAutoOrderingSettings & Object> = {
  openOrderSettings: _DEFAULT_USER_ACCESS_OPEN_ORDER_SETTINGS,
  orderSettings: _DEFAULT_USER_ACCESS_ORDER_SETTINGS,
};
//#endregion
